import { useTranslation } from "@coworker/locales";
import FixaSSRIcon from "../../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import InformationCircleIconPath from "../../../shared/wrappers/FixaSSRIcon/paths/InformationCircleIconPath";
import styles from "./task-notification.module.css";

export const TaskNotificationPriority = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["task-notification-item-body-priority"] ?? ""}>
      <FixaSSRIcon paths={InformationCircleIconPath} />
      {t("priorityString")}
    </div>
  );
};
